import { ProductReviewsRatingStars } from '@/app/[locale]/product/[slug]/_components/product-reviews/rating/stars'
import { useTranslations } from 'next-intl'

type Props = {
  reviewAvg: number
  reviewCount: number
}

export const ProductReviewsRating = ({ reviewAvg, reviewCount }: Props) => {
  const rawRating = reviewAvg > 5 ? reviewAvg / 2 : reviewAvg
  const rating = Math.floor(rawRating * 10) / 10
  const t = useTranslations('product_detail.title')

  return (
    <>
      <div className='flex items-baseline gap-1.5 lg:items-center lg:gap-3'>
        <p className='font-criteria text-[40px] font-medium leading-7 text-neutral-900 lg:text-[80px] lg:leading-14'>
          {rating}
        </p>
        <div>
          <ProductReviewsRatingStars rating={rawRating} />
          <p className='mt-1 font-sans text-sm leading-4.5 text-neutral-500 max-lg:hidden'>
            {t.rich('based_on_reviews_customer', {
              count: reviewCount,
            })}
          </p>
        </div>
      </div>
      <p className='mt-1 font-sans text-xs text-neutral-500 lg:hidden'>
        {t.rich('based_on_reviews_customer', {
          count: reviewCount,
        })}
      </p>
    </>
  )
}
